import React from "react";
import ReactTooltip from "react-tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { Box } from "@material-ui/core";
import { useStyles } from "./styles";
import { DOWNLOAD } from "../../constants/index";

function DownloadIcon({ downloadFile, item, documentTypeId }) {
  return item.documents &&
    item.documents[documentTypeId] &&
    item?.documents[documentTypeId].url ? (
    <Box
      data-tip={`${DOWNLOAD} ${item?.documents[documentTypeId].title}`}
      m={2}
      onClick={() => downloadFile(item?.documents[documentTypeId].url)}
    >
      <CloudDownloadIcon fontSize={"large"} />
      <ReactTooltip html={true} />
    </Box>
  ) : (
    ""
  );
}

export default withStyles(useStyles, { withTheme: true })(DownloadIcon);
